export default __webpack_public_path__ + "static/media/file-web_darkGray3.2b9699cc.svg";